import type { GameReach } from "../api/types";

/**
 * Whether push counts toward joining. The server decides (`via`): with the
 * season's reachRequiresInstalledApp on, push in a plain browser tab is on but
 * does not count.
 */
export function pushCounts(reach: GameReach | null | undefined): boolean {
  return !!reach?.via?.includes("push");
}

/** Push is on, but the game only counts it from the installed app. */
export function pushNeedsApp(reach: GameReach | null | undefined): boolean {
  return reach?.push.state === "ok" && !pushCounts(reach);
}
